<template>
  <div id="Vehicles">
    <SovecoNavBar />

    <modal
      name="floatdrivers"
      :draggable="false"
      :width="300"
      :height="430"
      :pivotX="shiftX"
      :pivotY="shiftY"
      :clickToClose="false"
    >
      <div>
        <div class="flex-container floatDriverEsc">
          <div class="flex-box-larger pl-1">Lista Autisti</div>
          <button @click="$modal.hide('floatdrivers')">x</button>
        </div>
        <div class="floatDriverWin">
          <ul>
            <li
              v-for="item in driversRows"
              :key="item.id"
              @mouseover="mouseOver(item)"
              :class="[
                item === driverMouseSel
                  ? 'is-item-selected'
                  : 'is-item-not-selected',
                '',
              ]"
              @click="closeSelectDriver()"
            >
              {{ item.cognome }}&nbsp;{{ item.nome }}&nbsp;{{ item.nick }}
            </li>
          </ul>
        </div>
      </div>
    </modal>

    <div class="columns is-variable">
      <div class="column is-narrow">
        <div class="vehicles_top_box">MEZZI</div>
        <VueScrollTable
          :options="vehiclesOpts"
          :columns="vehiclesCols"
          :rows="vehiclesRows"
        />
      </div>
      <div class="column">
        <div class="tabs is-boxed is-marginless">
          <ul class="vehicles_top_tabs">
            <template v-if="auth.tipo !== 3">
              <li :class="isTabActive(0)" @click="tabNo = 0">
                <a>Assegnazione Autisti</a>
              </li>
              <li :class="isTabActive(1)" @click="tabNo = 1">
                <a>Diario Autisti</a>
              </li>
            </template>
            <li :class="isTabActive(2)" @click="tabNo = 2">
              <a>Notifiche</a>
            </li>
            <li :class="isTabActive(3)" @click="tabNo = 3">
              <a>Scheda veicolo</a>
            </li>
            <li :class="isTabActive(4)" @click="tabNo = 4">
              <a>Progressivi</a>
            </li>
          </ul>
        </div>
        <template v-if="tabNo === 4">
          <div class="vehicles_scheda">
            <div class="columns">
              <div class="column is-half">
                <div class="box">
                  <h2 class="title is-4">Progressivi KM e Ore Guida</h2>
                  <div class="field">
                    <label class="label">Veicolo</label>
                    <div class="control">
                      <input
                        :value="vehicleSel.targa || 'Nessun veicolo selezionato'"
                        disabled
                        class="input is-disabled"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">Km Progressivi</label>
                    <div class="control">
                      <input
                        v-model="progressivi.km_progressivo"
                        class="input"
                        type="number"
                        step="0.01"
                        placeholder="0.00"
                        :disabled="isEmptyObject(vehicleSel)"
                      />
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">Ore di guida</label>
                    <div class="control">
                      <input
                        v-model="progressivi.ore_guida"
                        class="input"
                        type="number"
                        step="1"
                        placeholder="0"
                        :disabled="isEmptyObject(vehicleSel)"
                      />
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">Data inizio conteggio</label>
                    <div class="control">
                      <input
                        v-model="progressivi.data_inizio"
                        class="input"
                        type="date"
                        :disabled="isEmptyObject(vehicleSel)"
                      />
                    </div>
                    <p class="help">Imposta la data di inizio per calcolare i progressivi. Lascia vuoto se i dati partono da zero.</p>
                  </div>
                  <div class="field">
                    <label class="label">Ultimo aggiornamento</label>
                    <div class="control">
                      <input
                        v-model="progressivi.ultimo_aggiornamento"
                        disabled
                        class="input is-disabled"
                        type="text"
                        placeholder="Mai aggiornato"
                      />
                    </div>
                  </div>
                  <div class="field">
                    <button
                      class="button is-success is-medium"
                      @click="saveProgressivi"
                      :disabled="isEmptyObject(vehicleSel)"
                    >
                      Salva Progressivi
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="tabNo === 3">
          <div class="vehicles_scheda">
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">Targa</label>
                  <div class="control">
                    <input
                      v-model="vehicleSel.targa"
                      disabled
                      class="input is-disabled"
                      type="text"
                      placeholder
                    />
                  </div>
                </div>
                <div class="field">
                  <label class="label">Tipo</label>
                  <div class="control">
                    <input
                      v-model="vehicleSel.tipo"
                      disabled
                      class="input is-disabled"
                      type="text"
                      placeholder
                    />
                  </div>
                </div>
                <div class="field">
                  <label class="label">Marca</label>
                  <div class="control">
                    <input
                      v-model="vehicleSel.marca"
                      disabled
                      class="input is-disabled"
                      type="text"
                      placeholder
                    />
                  </div>
                </div>
                <div class="field">
                  <label class="label">Modello</label>
                  <div class="control">
                    <input
                      v-model="vehicleSel.modello"
                      disabled
                      class="input is-disabled"
                      type="text"
                      placeholder
                    />
                  </div>
                </div>
                <div class="field">
                  <label class="label">Colore</label>
                  <div class="control">
                    <input
                      v-model="vehicleSel.colore"
                      disabled
                      class="input is-disabled"
                      type="text"
                      placeholder
                    />
                  </div>
                </div>
                <div class="field">
                  <label class="label">Sonde</label>
                  <div class="control">
                    <input
                      v-model="vehicleSel.sonde"
                      disabled
                      class="input is-disabled"
                      type="text"
                      placeholder
                    />
                  </div>
                </div>
                <div class="field">
                  <label class="label">Autista attuale</label>
                  <div class="control">
                    <input
                      v-model="vehicleSel.driver"
                      disabled
                      class="input is-disabled"
                      type="text"
                      placeholder
                    />
                  </div>
                </div>
              </div>
              <div class="column">
                <div v-if="!isEmptyObject(vehicleSel)">
                  <img
                    v-if="imageSrc"
                    :src="imageSrc"
                    alt="Image"
                    class="vehicle-image"
                  />
                  <!-- File Input -->
                  <div class="columns">
                    <div class="column">
                      <input type="file" @change="onFileChange" />
                    </div>
                    <div class="column">
                      <!-- Upload Button -->
                      <button @click="uploadFile">Carica immagine</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-else-if="tabNo === 0">
          <div class="columns pt-2">
            <div class="column is-one-third">
              <div class="field">
                <label class="label pl-4">Mezzo selezionato</label>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label pl-4">Nuova assegnazione</label>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-one-third">
              <div class="box">
                <div class="field">
                  <label class="label">Mezzo :</label>
                  <div class="control">
                    <input
                      disabled
                      class="input is-disabled"
                      type="text"
                      placeholder
                      :value="vehicleSelected()"
                    />
                  </div>
                </div>
                <!-- <div v-if="logRows.length !== 0"> -->
                <!-- <div class="field">
                    <label class="label"
                      >Attualmente assegnato all'autista :</label
                    >
                    <div class="control">
                      <input
                        disabled
                        class="input is-disabled"
                        type="text"
                        placeholder
                        :value="vehicleSelectedStatus()"
                      />
                    </div>
                  </div>

                  <div class="field">
                    <label class="label">dal :</label>
                    <div class="control">
                      <input
                        disabled
                        class="input is-disabled"
                        type="text"
                        placeholder
                        :value="logRows[0].check_in"
                      />
                    </div>
                  </div>

                  <div class="field">
                    <label class="label">note :</label>
                    <div class="control">
                      <input
                        disabled
                        class="input is-disabled"
                        type="text"
                        placeholder
                        :value="logRows[0].note_log"
                      />
                    </div>
                  </div> -->
                <div class="field">
                  <button
                    :disabled="cantRemove()"
                    class="button is-danger is-pulled-left"
                    @click="doAssign(false)"
                  >
                    Rimuovi Assegnazione
                  </button>
                </div>
                <div class="field">
                  <label class="label pb-5 pt-4"> </label>
                </div>
                <!-- </div> -->
              </div>
            </div>
            <div class="column">
              <div class="box">
                <div class="columns">
                  <div class="column">
                    <div class="field">
                      <label class="label">Autista selezionato :</label>
                      <div class="flex-container">
                        <div class="control">
                          <a class="button" @click="doSelectDriver($event)"
                            >Lista Autisti</a
                          >
                        </div>
                        <div class="control flex-box-larger">
                          <input
                            type="text"
                            class="input is-disabled"
                            disabled
                            placeholder="Scegliere autista"
                            :value="driverSelected()"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- <div class="field pb-5">
                      <label class="label">Data e ora inizio</label>
                      <div class="control">
                        <date-picker
                          v-model="startData"
                          type="datetime"
                          value-type="YYYY-MM-DD HH:mm"
                          format="DD-MM-YYYY HH:mm"
                          confirm
                        />
                      </div>
                    </div> -->
                    <span
                      class="button is-success buttonsize is-pulled-left"
                      :disabled="isEmptyObject(driverSel)"
                      @click="doAssign(true)"
                      >Assegna</span
                    >
                  </div>
                  <!-- <div class="column">
                    <div class="field">
                      <label class="label"
                        >Attualmente assegnato al mezzo :</label
                      >
                      <div class="control">
                        <input
                          disabled
                          class="input is-disabled"
                          type="text"
                          placeholder
                          :value="driverSelectedStatus()"
                        />
                      </div>
                      <div class="field">
                        <label class="label">Note</label>
                        <div class="control">
                          <textarea
                            v-model="notes"
                            class="textarea"
                            placeholder="note"
                          />
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="tabNo === 1">
          <div class="vehicles_scheda">
            <div class="columns">
              <div class="column">
                <label class="label"
                  >Diario autisti del mezzo : {{ vehicleSel.targa }}</label
                >
                <VueScrollTable
                  :options="logROpts"
                  :columns="logRCols"
                  :rows="logRows"
                />
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="tabNo === 2">
          <div class="vehicles_scheda">
            <div v-if="isEmptyObject(vehicleSel)">
              <label class="label">Selezionare un mezzo</label>
            </div>
            <div v-else>
              <table width="100%">
                <tr>
                  <td width="33%">
                    <div class="sr_bold sr_green">{{ vehicleSel.targa }}</div>
                  </td>
                  <td width="33%">
                    <label class="label">{{ vehicleSel.tipo }}</label>
                  </td>
                  <td width="33%" />
                </tr>
                <tr>
                  <td width="33%">
                    <label class="label">{{ vehicleSel.marca }}</label>
                  </td>
                  <td width="33%">
                    <label class="label">{{ vehicleSel.modello }}</label>
                  </td>
                  <td width="33%">
                    <label class="label">{{ vehicleSel.colore }}</label>
                  </td>
                </tr>
              </table>
            </div>
            <div class="notifiche_scheda">
              <label class="label">Eventi da notificare</label>
              <multiselect
                v-model="tagValues"
                tag-placeholder="Aggiungi evento"
                placeholder="Cerca/aggiunge filtro"
                select-label="Premi return per selezionare"
                selected="Selezionato"
                deselect-label="Premi return per rimuovere"
                label="segnale"
                track-by="id"
                :options="tags"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
              />
              <pre class="language-json"><code>{{ value }}</code></pre>
              <div class="notifiche_scheda">
                <div class="field">
                  <label class="label">email #1</label>
                  <div class="control">
                    <input
                      v-model="email_1"
                      class="input"
                      type="text"
                      placeholder
                    />
                  </div>
                </div>
                <div class="field">
                  <label class="label">email #2</label>
                  <div class="control">
                    <input
                      v-model="email_2"
                      class="input"
                      type="text"
                      placeholder
                    />
                  </div>
                </div>
                <div class="field">
                  <label class="label">email #3</label>
                  <div class="control">
                    <input
                      v-model="email_3"
                      class="input is-"
                      type="text"
                      placeholder
                    />
                  </div>
                </div>
                <div class="field">
                  <label class="label">email #4</label>
                  <div class="control">
                    <input
                      v-model="email_4"
                      class="input is-"
                      type="text"
                      placeholder
                    />
                  </div>
                </div>
              </div>

              <div class="columns">
                <div class="column has-text-centered">
                  <span
                    class="button is-danger buttonsize"
                    @click="deleteNotifica"
                    >Elimina</span
                  >
                </div>
                <div class="column has-text-centered">
                  <button
                    class="button is-success buttonsize"
                    @click="saveNotifica"
                  >
                    Salva
                  </button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from 'vue'
import axios from 'axios'
import { ServiceBus } from '../ServiceBus.js'
import { UtilityMixin } from '../mixins/UtilityMixin.js'
import VueScrollTable from './reusable/VueScrollTable.vue'

// import DatePicker from 'vue2-datepicker'
// import 'vue2-datepicker/index.css'
// import 'vue2-datepicker/locale/it'

export default {
  name: 'Vehicles',
  components: {
    VueScrollTable,
    // DatePicker,
  },
  mixins: [UtilityMixin],
  watch: {
    // Watcher rimosso: ore_guida è un campo editabile diretto
  },
  data() {
    return {
      shiftX: 0.5,
      shiftY: 0.5,
      api_server: '',
      auth: null,
      prefs: null,
      windowHeight: 0,
      windowWidth: 0,
      tabNo: 0,
      vehiclesRows: [],
      logRows: [],
      driversRows: [],
      vehicleSel: {},
      driverVehicle: null,
      isActive: false,
      logSel: {},
      driverSel: {},
      driverMouseSel: {},
      startData: '',
      notes: '',
      tags: [],
      tagValues: [],
      email_1: '',
      email_2: '',
      email_3: '',
      email_4: '',
      imgs: [],
      imageSrc: null,
      possibleExtensions: ['jpg', 'png', 'jpeg', 'gif'],
      progressivi: {
        km_progressivo: 0,
        ore_guida: 0,
        data_inizio: null,
        ultimo_aggiornamento: null,
      },
      vehiclesOpts: {
        id: 'VH01',
        isResizeable: false,
        isSelectable: true,
        cssContainer: 'vehicles_lc',
        cssHeader: 'vehicles_lh',
        cssBody: 'vehicles_l',
        cssRows: 'vehicles_l',
        order_col: 'targa',
      },
      vehiclesCols: [
        {
          id: 'targa',
          visible: true,
          f_type: '*',
          title: 'Targa',
          width: 80,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: 0,
          image: false,
        },
        {
          id: 'autista',
          visible: true,
          f_type: '*',
          title: 'Autista',
          width: 180,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: 1,
          image: false,
        },
      ],
      /*
              {id: "marca",visible: true,title: "Marca",width: 150,alignment_th: '',alignment_td: '',elastic: true,filter: "",order: 1,image: false},
              {id: "modello",visible: true,title: "Modello",width: 150,alignment_th: '',alignment_td: '',elastic: true,filter: "",order: 1,image: false},
              {id: "tipo",visible: true,title: "Tipo",width: 200,alignment_th: '',alignment_td: '',elastic: true,filter: "",order: 1,image: false},
              {id: "sonda_1",visible: true,title: "S1",width: 50,alignment_th: 'center_align',alignment_td: 'center_align',elastic: false,filter: "",order: 1,image: false},
              {id: "sonda_2",visible: true,title: "S2",width: 50,alignment_th: 'center_align',alignment_td: 'center_align',elastic: false,filter: "",order: 1,image: false},
              {id: "sonda_3",visible: true,title: "S3",width: 50,alignment_th: 'center_align',alignment_td: 'center_align',elastic: false,filter: "",order: 1,image: false},
              {id: "sonda_4",visible: true,title: "S4",width: 50,alignment_th: 'center_align',alignment_td: 'center_align',elastic: false,filter: "",order: 1,image: false}
            */
      mouseOver(obj) {
        this.driverMouseSel = obj
      },
      logROpts: {
        id: 'VH02',
        isResizeable: false,
        isSelectable: true,
        cssContainer: 'logr_vehicles_lc',
        cssHeader: 'logr_vehicles_lh',
        cssBody: 'logr_vehicles_l',
        cssRows: 'logr_vehicles_l',
        order_col: 'check_in',
      },
      logRCols: [
        {
          id: 'date_ope',
          visible: true,
          f_type: '*',
          title: 'Data',
          width: 140,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: 1,
          image: false,
        },
        // {
        //   id: 'check_out',
        //   visible: true,
        //   f_type: '*',
        //   title: 'al',
        //   width: 140,
        //   alignment_th: '',
        //   alignment_td: '',
        //   elastic: false,
        //   filter: '',
        //   order: 1,
        //   image: false,
        // },
        {
          id: 'cognome',
          visible: true,
          f_type: '*',
          title: 'Cognome',
          width: 90,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: -1,
          image: false,
        },
        {
          id: 'nome',
          visible: true,
          title: 'Nome',
          f_type: '*',
          width: 90,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: -1,
          image: false,
        },
        {
          id: 'nick',
          visible: true,
          title: 'Alias',
          width: 80,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: -1,
          image: false,
        },
        {
          id: 'ope',
          visible: true,
          f_type: '*',
          title: 'Operazione',
          width: 200,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: -1,
          image: false,
        },
      ],
      logOpts: {
        id: 'VH03',
        isResizeable: false,
        isSelectable: false,
        cssContainer: 'log_vehicles_lc',
        cssHeader: 'log_vehicles_lh',
        cssBody: 'log_vehicles_l',
        cssRows: 'log_vehicles_l',
        order_col: 'check_in',
      },
      logCols: [
        {
          id: 'check_in',
          visible: true,
          f_type: '*',
          title: 'Dal',
          width: 140,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'check_out',
          visible: true,
          f_type: '*',
          title: 'al',
          width: 140,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'autista',
          visible: true,
          f_type: '*',
          title: 'Autista',
          width: 100,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: -1,
          image: false,
        },
        {
          id: 'note_log',
          visible: true,
          f_type: '*',
          title: 'Note',
          width: 80,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: -1,
          image: false,
        },
      ],
      driversOpts: {
        id: 'VH04',
        isResizeable: true,
        isSelectable: true,
        cssContainer: 'drivers_vehicles_lc',
        cssHeader: 'drivers_vehicles_lh',
        cssBody: 'drivers_vehicles_l',
        cssRows: 'drivers_vehicles_l',
        order_col: 'nick',
      },
      driversCols: [
        {
          id: 'cognome',
          visible: true,
          f_type: '*',
          title: 'Cognome',
          width: 110,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'nome',
          visible: true,
          f_type: '*',
          title: 'Nome',
          width: 110,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'nick',
          visible: true,
          f_type: '*',
          title: 'Alias',
          width: 100,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'note_driver',
          visible: true,
          f_type: '*',
          title: 'Note',
          width: 180,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: -1,
          image: false,
        },
      ],
    }
  },
  created() {
    const vm = this
    vm.prefs = JSON.parse(vm.$localStorage.get('prefs'))
    vm.auth = JSON.parse(vm.$localStorage.get('auth'))
  },
  mounted() {
    const vm = this
    vm.api_server = vm.getApiServer()
    if (vm.auth === null || vm.auth.tipo === 3) {
      vm.tabNo = 2
    }
    vm.$nextTick(function () {
      window.removeEventListener('resize', null)
      window.addEventListener('resize', vm.getWindowHeight)
      vm.getWindowHeight()
      vm.doGetVehicles()

      vm.do_get_tags()

      setTimeout(function () {
        let v_cod = vm.$localStorage.get('vehicles_cod')
        if (v_cod !== '' && v_cod !== null) {
          let a = vm.findObjInArray(vm.vehiclesRows, 'cod', v_cod)
          let idx = vm.findObjIndexInArray(vm.vehiclesRows, 'cod', v_cod)
          ServiceBus.$emit('select', a)
          ServiceBus.$emit('scroll', idx)
          vm.selectEntry(a)
          vm.$localStorage.set('vehicles_cod', '')
        }
      }, 1000)
    })
  },
  methods: {
    loadImage() {
      const vm = this
      if (this.isEmptyObject(vm.vehicleSel)) return
      const imgName = vm.auth.cod + '_' + vm.vehicleSel.cod

      const postfix = vm.getServerPostfix()
      const basePath =
        'https://www.sovecotech' + postfix + '/sovtech/media/uploads/'
      const defaultImage =
        'https://www.sovecotech' +
        postfix +
        '/sovtech/media/uploads/noimage.png'
      let imageFound = false

      this.possibleExtensions.some((extension) => {
        const imgPath = `${basePath}${imgName}.${extension}?${Date.now()}`
        const img = new Image()

        // Check if the image loads successfully
        img.onload = () => {
          if (!imageFound) {
            this.imageSrc = imgPath // Set the image source to the found image
            imageFound = true // Mark that an image has been found
          }
        }

        // Handle error (image not found for this extension)
        img.onerror = () => {
          if (
            extension ===
              this.possibleExtensions[this.possibleExtensions.length - 1] &&
            !imageFound
          ) {
            this.imageSrc = defaultImage // Set the image to the default image if nothing is found
          }
        }
        img.removeAttribute('src')
        img.src = imgPath
        img.style = 'height: 300px;object-fit: contain;'

        // Stop if an image is successfully loaded
        return imageFound
      })

      // If no image is found by the end of the loop, set the default image
      if (!imageFound) {
        this.imageSrc = defaultImage
      }
    },
    /*
    loadImage() {
      // Iterate through the possible extensions and check if the image exists
      const vm = this
      if (this.isEmptyObject(vm.vehicleSel)) return
      const imgName = vm.auth.cod + '_' + vm.vehicleSel.cod
      const basePath = 'https://www.sovecotech.com/sovtech/media/uploads/'

      vm.possibleExtensions.some((extension) => {
        const imgPath = `${basePath}${imgName}.${extension}`
        const img = new Image()

        // Check if the image loads successfully
        img.onload = () => {
          this.imageSrc = imgPath
        }

        // Set the image src to test if it loads
        img.src = imgPath

        // Stop once we find a valid image
        return img.complete
      })
    },
    */
    onFileChange(event) {
      this.imgs = event.target.files[0] // Access the selected file

      console.log(this.imgs)
    },
    uploadFile() {
      const vm = this

      const id_image = vm.auth.cod + '_' + vm.vehicleSel.cod
      this._uploadFile(vm.imgs, id_image, function (error, data) {
        if (error) {
          console.error('Callback Error:', error)
        } else {
          console.log('Callback Success:', data)
        }
        vm.loadImage()
      })
    },

    _uploadFile(selectedFile, id_image, callback) {
      const vm = this
      if (!selectedFile) {
        alert('Please select a file!')
        return
      }

      const postfix = vm.getServerPostfix()
      // Create a FormData object and append the file
      let formData = new FormData()
      formData.append('file', selectedFile)
      formData.append('id_image', id_image) // Append the string

      // Make a POST request with axios
      console.log('chiamo api')
      axios
        .post(
          'https://www.sovecotech' + postfix + '/sovtech/media/upload.php',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )
        .then(function (response) {
          // Handle the response
          console.log('File uploaded successfully:', response.data)

          // Call the callback with the response data
          if (callback) {
            callback(null, response.data)
          }
        })
        .catch(function (error) {
          // Handle the error
          console.error('Error uploading file:', error)

          // Call the callback with the error
          if (callback) {
            callback(error)
          }
        })
    },

    isTabActive(t) {
      const vm = this
      if (vm.tabNo == 0 || vm.tabNo == 1) {
        setTimeout(function () {
          vm.getWindowHeight(null)
        }, 40)
      }

      if (vm.tabNo == t) {
        if (vm.tabNo == 1) {
          let d = new Date()
          vm.startData = d.toLocaleMysqlString()
        }
        return 'is-active'
      } else {
        return ''
      }
    },
    cancelEntry() {
      const vm = this
      ServiceBus.$emit('deselect')
      vm.notes = ''
      vm.startData = null
      vm.driverSel = {}
      vm.vehicleSel = {}
      vm.logRows = []
      vm.clearProgressivi()
    },
    cantRemove() {
      const vm = this
      return vm.driverVehicle === null
      // const vm = this
      // if (vm.logRows.length > 0) {
      //   return vm.logRows[0].check_out === null
      // }
      // return false
    },
    vehicleSelectedStatus() {
      const vm = this
      if (vm.isEmptyObject(vm.vehicleSel)) {
        return '-'
      } else {
        if (vm.vehicleSel.cognome === null || vm.driverSel.cognome === '') {
          return 'Non assegnato'
        } else {
          return (
            vm.vehicleSel.nome +
            ' ' +
            vm.vehicleSel.cognome +
            ' / ' +
            vm.vehicleSel.nick
          )
        }
      }
    },
    vehicleSelected() {
      const vm = this
      if (vm.isEmptyObject(vm.vehicleSel)) {
        return 'Selezionare un mezzo'
      } else {
        return (
          vm.vehicleSel.targa +
          ' : ' +
          vm.vehicleSel.cognome +
          ' ' +
          vm.vehicleSel.nome +
          ' ' +
          vm.vehicleSel.nick
        )
      }
    },
    driverSelectedStatus() {
      const vm = this
      if (vm.isEmptyObject(vm.driverSel)) {
        return '-'
      } else {
        if (vm.driverSel.targa === null || vm.driverSel.targa === '') {
          return 'Non assegnato'
        } else {
          return vm.driverSel.targa
        }
      }
    },
    getDriverName(obj) {
      if (obj.cognome === null || typeof obj.cognome === 'undefined') {
        return '****'
      } else {
        return obj.cognome + ' ' + obj.nome + ' / ' + obj.nick
      }
    },
    driverSelected() {
      const vm = this
      if (vm.isEmptyObject(vm.driverSel)) {
        return 'Selezionare un autista'
      } else {
        return vm.getDriverName(vm.driverSel)
      }
    },
    colClick(id, col, item, event) {
      const vm = this

      if (id == 'VH02') {
        vm.logSel = item
      }
      if (id == 'VH04') {
        vm.driverSel = item
        vm.startData = new Date().toLocaleMysqlString()
      }
      if (id == 'VH01') {
        vm.selectEntry(item)
      }
    },
    closeSelectDriver() {
      const vm = this
      vm.driverSel = vm.driverMouseSel
      vm.$modal.hide('floatdrivers')
    },
    doSelectDriver(event) {
      const vm = this
      vm.shiftY = event.clientY / vm.windowHeight
      vm.shiftX = event.clientX / vm.windowWidth
      vm.$modal.show('floatdrivers')
    },
    async selectEntry(item) {
      const vm = this
      vm.vehicleSel = item
      vm.loadImage()
      vm.vehicleSel.sonde =
        vm.getSondaName(item.sonda_1) +
        vm.getSondaName(item.sonda_2) +
        vm.getSondaName(item.sonda_3) +
        vm.getSondaName(item.sonda_4)
      vm.vehicleSel.driver =
        vm.nullString(vm.vehicleSel.cognome) +
        ' ' +
        vm.nullString(vm.vehicleSel.nome) +
        ' / ' +
        vm.nullString(vm.vehicleSel.nick)
      if (vm.vehicleSel.id) {
        vm.driverVehicle = await ServiceBus._getDriver(vm.vehicleSel.id)
      } else {
        vm.driverVehicle = null
      }
      await vm.doGetLog()
      await vm.doGetNotifica()
      await vm.loadProgressivi()
    },
    async loadProgressivi() {
      const vm = this
      if (vm.isEmptyObject(vm.vehicleSel)) {
        vm.clearProgressivi()
        return
      }

      try {
        const response = await axios.get(
          vm.api_server + 'get_progressivi/' + vm.vehicleSel.cod,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          if (response.data && response.data.cod) {
            vm.progressivi.km_progressivo = response.data.km_progressivo || 0
            const minuti_progressivi = response.data.minuti_progressivi || 0
            // Converti minuti in ore arrotondate
            vm.progressivi.ore_guida = Math.round(minuti_progressivi / 60)
            vm.progressivi.data_inizio = response.data.data_inizio || null
            vm.progressivi.ultimo_aggiornamento = response.data.ultimo_aggiornamento || null
          } else {
            vm.clearProgressivi()
          }
        }
      } catch (e) {
        console.log('Progressivi non trovati o errore:', e)
        vm.clearProgressivi()
      }
    },
    clearProgressivi() {
      const vm = this
      vm.progressivi.km_progressivo = 0
      vm.progressivi.ore_guida = 0
      vm.progressivi.data_inizio = null
      vm.progressivi.ultimo_aggiornamento = null
    },
    async saveProgressivi() {
      const vm = this
      if (vm.isEmptyObject(vm.vehicleSel)) {
        vm.$dialog
          .alert('Nessun veicolo selezionato')
          .then(function () {})
          .catch(function () {})
        return
      }

      try {
        // Converti ore in minuti per il salvataggio
        const minuti_progressivi = (vm.progressivi.ore_guida || 0) * 60

        const response = await axios.post(
          vm.api_server + 'save_progressivi',
          {
            cod: vm.vehicleSel.cod,
            km_progressivo: vm.progressivi.km_progressivo || 0,
            minuti_progressivi: minuti_progressivi,
            data_inizio: vm.progressivi.data_inizio || null,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          vm.$dialog
            .alert('Progressivi salvati con successo')
            .then(function () {})
            .catch(function () {})
          // Ricarica i dati aggiornati
          await vm.loadProgressivi()
        }
      } catch (e) {
        console.log('Errore salvataggio progressivi:', e)
        vm.$dialog
          .alert('Errore durante il salvataggio dei progressivi')
          .then(function () {})
          .catch(function () {})
      }
    },
    insertTagValues(data) {
      const vm = this
      let obj
      let a = data.split('|')
      vm.tagValues = []
      for (let i = 0; i < a.length; i++) {
        obj = vm.findObjInArray(vm.tags, 'segnale', a[i])
        if (obj) {
          vm.tagValues.push(obj)
        }
      }
    },
    getTagValuesStr() {
      const vm = this
      let str = ''
      let sep = ''
      if (vm.tagValues.length > 0) {
        for (let i = 0; i < vm.tagValues.length; i++) {
          str = str + sep + vm.tagValues[i].segnale
          if (sep.length === 0) sep = '|'
        }
      }
      return str
    },
    async doAssign(isNewAssign) {
      const vm = this
      if (isNewAssign) {
        await vm.doAssignDriver()
      } else {
        await vm.doRemoveAssignDriver()
      }
      vm.logRows = []
    },
    clearNotifica() {
      const vm = this
      vm.email_1 = vm.email_2 = vm.email_3 = vm.email_4 = ''
      vm.tagValues = []
    },
    deleteNotifica() {
      const vm = this
      if (vm.isEmptyObject(vm.vehicleSel)) {
        vm.$dialog
          .alert('Nessun veicolo selezionato')
          .then(function () {})
          .catch(function () {})
      } else {
        const vm = this
        vm.doDeleteNotifica()
        vm.clearNotifica()
      }
    },
    saveNotifica() {
      const vm = this
      if (vm.isEmptyObject(vm.vehicleSel)) {
        vm.$dialog
          .alert('Nessun veicolo selezionato')
          .then(function () {})
          .catch(function () {})
      } else {
        let mssg = vm.getTagValuesStr()
        if (mssg === '') {
          vm.$dialog
            .alert('Nessuna evento inserito')
            .then(function () {})
            .catch(function () {})
        } else {
          vm.doInsertNotifica(mssg)
        }
      }
    },
    addTag(newTag) {
      const vm = this
      const tag = {
        segnale: newTag,
        id: vm.tags.length + 1,
      }
      vm.tags.push(tag)
      vm.tagValues.push(tag)
    },

    async doGetVehicles() {
      const vm = this
      vm.vehiclesRows = await ServiceBus._doGetVehicles()
      vm.driversRows = await ServiceBus._doGetDrivers()
    },

    async doAssignDriver() {
      const vm = this
      if (vm.driverVehicle) {
        vm.driverVehicle.cod_vehicle = ''
        await ServiceBus._updateDriver(vm.driverVehicle)
      }
      if (vm.driverSel) {
        vm.driverSel.cod_vehicle = vm.vehicleSel.cod

        await ServiceBus._updateDriver(vm.driverSel)
      }
      vm.doGetVehicles()
      vm.cancelEntry()
    },

    async doRemoveAssignDriver() {
      const vm = this
      if (vm.driverVehicle) {
        vm.driverVehicle.cod_vehicle = ''
        await ServiceBus._updateDriver(vm.driverVehicle)
      }
      vm.doGetVehicles()
      vm.cancelEntry()
    },

    // async doAssignDriver2(isNewAssign) {
    //   const vm = this
    //   console.log(vm.vehicleSel)
    //   let newdriver = -1
    //   if (isNewAssign) {
    //     newdriver = vm.driverSel.id
    //   }
    //   try {
    //     let start = new Date(vm.startData).toLocaleMysqlString()
    //     const response = await axios.post(
    //       vm.api_server + 'assign_driver',
    //       {
    //         old_driver: vm.vehicleSel.id,
    //         check_date: start,
    //         new_driver: newdriver,
    //         vehicle_cod: vm.vehicleSel.cod,
    //         notes: vm.notes,
    //         user_cod: vm.auth.cod,
    //         new_driver_uid: vm.driverSel.id_unique,
    //         old_driver_uid: vm.vehicleSel.id_unique,
    //       },
    //       {
    //         headers: {
    //           Authorization: vm.auth.tkn,
    //         },
    //       }
    //     )
    //     //vm.doGetLog();
    //     vm.doGetVehicles()
    //     vm.cancelEntry()
    //   } catch (e) {
    //     console.log('error ' + e)
    //   }
    // },
    async doGetLog() {
      const vm = this
      try {
        const response = await axios.get(
          vm.api_server +
            'get_vehicle_driver_log/' +
            vm.vehicleSel.cod +
            '/' +
            vm.vehicleSel.cod,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          vm.logRows = response.data
          vm.logRows.forEach((element) => {
            if (element.cod_vehicle_pre === vm.vehicleSel.cod) {
              element.ope = 'RIMOSSO'
            } else {
              element.ope = 'ASSEGNATO'
            }
          })
          vm.logRows.sort((a, b) => {
            if (a.date_ope < b.date_ope) return 1
            if (a.date_ope > b.date_ope) return -1
            if (a.ope > b.ope) return 1
            if (a.ope < b.ope) return -1
            return 0
          })
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },
    async do_get_tags() {
      const vm = this
      try {
        const response = await axios.get(vm.api_server + 'get_tags', {
          headers: {
            Authorization: this.auth.tkn,
          },
        })
        if (this.checkTkn(response.data)) {
          this.tags = response.data
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },
    async doGetNotifica() {
      const vm = this
      vm.clearNotifica()
      try {
        const response = await axios.get(
          vm.api_server + 'get_notifica/' + vm.vehicleSel.cod,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          if (response.data) {
            vm.email_1 = response.data.email_1
            vm.email_2 = response.data.email_2
            vm.email_3 = response.data.email_3
            vm.email_4 = response.data.email_4

            vm.insertTagValues(response.data.message)
          } else {
            vm.tagValues = []
          }
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },
    async doInsertNotifica(mssg) {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'insert_notifica',
          {
            cod: vm.vehicleSel.cod,
            message: mssg,
            email_1: vm.email_1,
            email_2: vm.email_2,
            email_3: vm.email_3,
            email_4: vm.email_4,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        vm.$dialog
          .alert('Notifica inserita')
          .then(function () {})
          .catch(function () {})
      } catch (e) {
        console.log('error ' + e)
      }
    },
    async doDeleteNotifica() {
      const vm = this
      try {
        const response = await axios.delete(
          vm.api_server + 'delete_notifica/' + vm.vehicleSel.cod,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        vm.$dialog
          .alert('Notifica eliminata')
          .then(function () {})
          .catch(function () {})
      } catch (e) {
        console.log('error ' + e)
      }
    },
    getWindowHeight(event) {
      const vm = this
      vm.windowHeight = document.documentElement.clientHeight
      vm.windowWidth = document.documentElement.clientWidth
      document
        .getElementById(vm.vehiclesOpts.id + 'bw')
        .setAttribute('style', 'height:' + (vm.windowHeight - 150) + 'px')
      if (vm.tabNo == 1) {
        document
          .getElementById(vm.logROpts.id + 'bw')
          .setAttribute('style', 'height:' + (vm.windowHeight - 202) + 'px')
      }
    },
    beforeDestroy() {
      const vm = this
      window.removeEventListener('resize', vm.getWindowHeight)
    },
  },
}
</script>
